var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news_wrap"},[_c('div',{staticClass:"news"},[_c('page-header',{staticClass:"not_main"}),_c('div',{staticClass:"news_content"},[_c('image-component',{attrs:{"infoType":'newsBanner'}}),_c('board-list-component',{attrs:{"boardType":`news`}})],1),_c('page-footer',{staticClass:"not_main"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }